import { i18n } from 'services';

export const maxValue = (value: string | number, maxValue: number) => {
  return Number(value) > maxValue ? i18n.t('formValidationErrors.maxValue', { value: maxValue }) : undefined;
};
